import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class TransferLine implements ISerialize {
    public AlreadyExists: boolean;

    public Bib: number | null;

    public ContestantID: number;

    public GroupID: number;

    public LLSource: number | null;

    public RaceID: number;

    public SortOrder: number;

    public StartTime: Date | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        AlreadyExists?: boolean;
        Bib?: number | null;
        ContestantID?: number;
        GroupID?: number;
        LLSource?: number | null;
        RaceID?: number;
        SortOrder?: number;
        StartTime?: Date | null;
    }) {
        this.AlreadyExists = values.AlreadyExists ?? false;

        this.Bib = values.Bib ?? null;

        this.ContestantID = values.ContestantID ?? 0;

        this.GroupID = values.GroupID ?? 0;

        this.LLSource = values.LLSource ?? null;

        this.RaceID = values.RaceID ?? 0;

        this.SortOrder = values.SortOrder ?? 0;

        this.StartTime = values.StartTime ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"AlreadyExists": ${JSON.stringify(this.AlreadyExists)}` +
            ',' +
            `"Bib": ${JSON.stringify(this.Bib)}` +
            ',' +
            `"ContestantID": ${JSON.stringify(this.ContestantID)}` +
            ',' +
            `"GroupID": ${JSON.stringify(this.GroupID)}` +
            ',' +
            `"LLSource": ${JSON.stringify(this.LLSource)}` +
            ',' +
            `"RaceID": ${JSON.stringify(this.RaceID)}` +
            ',' +
            `"SortOrder": ${JSON.stringify(this.SortOrder)}` +
            ',' +
            `"StartTime": ${this.StartTime ? '"' + formatDateIso(this.StartTime) + '"' : null}` +
            '}'
        );
    }

    /**
     * Creates an instance of TransferLine from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        AlreadyExists?: boolean;
        Bib?: number | null;
        ContestantID?: number;
        GroupID?: number;
        LLSource?: number | null;
        RaceID?: number;
        SortOrder?: number;
        StartTime?: Date | null;
    }): TransferLine {
        return new TransferLine(values);
    }

    public static _FromServerJson(json: any): TransferLine {
        return new TransferLine({
            AlreadyExists: json.AlreadyExists,
            Bib: json.Bib ?? null,
            ContestantID: json.ContestantID,
            GroupID: json.GroupID,
            LLSource: json.LLSource ?? null,
            RaceID: json.RaceID,
            SortOrder: json.SortOrder,
            StartTime: json.StartTime ? (json.StartTime instanceof Date ? json.StartTime : new Date(json.StartTime)) : null,
        });
    }

    /**
     * Creates an instance of TransferLine from another instance of TransferLine.
     * @param other The TransferLine you want to clone
     * @returns A cloned TransferLine
     */
    public static FromOther(other: TransferLine): TransferLine {
        return TransferLine._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return TransferLine.FromOther(this);
    }

    static NAME_OF_CLASS = 'TransferLine';
}
